import React from "react";

import DispatcherCallSignCellContent from "../components/DispatcherCallSignCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function dispatcherCallSign({ width, onResize, language }: Column.Options) {
	return base(
		ColumnId.DispatcherCallSign,
		(item) => (
			<DispatcherCallSignCellContent item={item} language={language} />
		),
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default dispatcherCallSign;
